
import { Component, Input } from '@angular/core';

@Component({
  selector: 'flow-sidenav-item',
  templateUrl: './sidenav-item.component.html',
  styleUrls: ['./sidenav-item.component.scss'],
})
export class SidenavItemComponent {
  @Input() label: string;
  @Input() url: string;
  @Input() iconName: string;
  @Input() navMini: boolean;
}